<script setup lang="ts" generic="T extends string">
const props = defineProps<{
  product: SingleProduct;
  gradeOptions?: Options<T, { grades?: GradeCode[] }>;
  filterKey: "grade" | "level";
}>();

const enabled = computed<{ formats: Set<string>; grades: Set<string> }>(() => {
  const formats = new Set<string>();
  const grades = new Set<string>();

  for (const variant of props.product.variants) {
    if (variant.formats) {
      for (const format of variant.formats) {
        formats.add(format);
      }
    }

    if (variant.grades && props.gradeOptions) {
      for (const grade of variant.grades) {
        const option = props.gradeOptions.find(
          (it) => it.grades?.includes(grade) || it.value === grade,
        );

        if (option) {
          grades.add(option.value);
        }
      }
    }
  }

  return { formats, grades };
});
</script>

<template>
  <UiFilterContainer
    class="mx-auto -mt-16 bg-[--filter-background] p-6 text-[--filter-color] sm:w-fit lg:px-24 lg:py-12 xs:px-16 xs:py-8"
    title="Hva vil du se?"
    :filters="
      [
        gradeOptions
          ? {
            name: filterKey,
            legend: 'TRINN',
            enabled: enabled.grades,
            options: gradeOptions,
          }
          : undefined,
        {
          name: 'format',
          legend: 'PRODUKTTYPE',
          enabled: enabled.formats,
          options: PRODUCT_FORMAT_OPTIONS,
        },
      ].filter(truthy)
    "
  />
</template>
